<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[700px] desktop:w-[950px]">
    <div class="px-4 py-6 tablet:px-6 desktop:px-10">

      <!-- heading -->
      <strong class="block mb-8 pb-8 uppercase font-bold text-2xl border-b border-neutral-200 tablet:px-8">{{ $t('Dosažen maximální počet kusů') }}</strong>

      <!-- overcount -->
      <strong class="block mb-8 text-error-500">{{ $t('Bohužel jsme nemohli přidat do košíku požadované množství, protože není skladem. Aktuálně máte od tohoto produktu v košíku {0}', [$t('položku', dialog?.data.quantityInCart)]) }}.</strong>

      <!-- buttons -->
      <div class="text-center">
        <MoleculesButtonsButton @click="close">{{ $t('OK, beru na vědomí') }}</MoleculesButtonsButton>
      </div>

    </div>
  </AtomsGlobalDialog>
</template>
<script setup>

const close = () => useDialog().close();

const dialog = computed(() => useDialog().get('cartOvercount'));

</script>